export default __webpack_public_path__ + "static/media/S-043.75061d90.png";